import { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { DeleteOutline } from "@mui/icons-material";

const QuantityButton = ({
  initialQuantity = 1,
  min = 0,
  max = 99,
  onChange,
  theme = "light",
  background,
  textColor,
  outlined = true,
  outlinedColor = "black",
  width = "100%",
  disabled = true,
}) => {
  const [quantity, setQuantity] = useState(initialQuantity);

  useEffect(() => {
    setQuantity(initialQuantity);
  }, [initialQuantity]);

  const handleChange = (newQty) => {
    if (newQty < min || newQty > max) return;
    setQuantity(newQty);
    onChange?.(newQty);
  };

  return (
    <Container width={width}>
      <InnerContainer outlinedColor={outlinedColor} background={background} disabled={disabled}>
        <ControlButton
          aria-label="Decrease quantity"
          onClick={() => handleChange(quantity - 1)}
          disabled={quantity <= min || disabled}
          themeStyle={theme}
          outlined={outlined}
          background={background}
          textColor={textColor}
        >
          {quantity <= 1 ? (
            <DeleteOutline
              css={{ fontSize: "1.1rem", top: 0, position: "relative" }}
            />
          ) : (
            "-"
          )}
        </ControlButton>

        <QuantityText textColor={textColor} themeStyle={theme}>{quantity}</QuantityText>

        <ControlButton
          aria-label="Increase quantity"
          onClick={() => handleChange(quantity + 1)}
          disabled={quantity >= max || disabled}
          themeStyle={theme}
          outlined={outlined}
          background={background}
          textColor={textColor}
        >
          +
        </ControlButton>
      </InnerContainer>
    </Container>
  );
};

export default QuantityButton;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ width }) => width};
`;

const InnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 50px;
  font-size: 1.25rem;
  font-weight: bold;
  width: 100%;
  border: 1px solid ${({ outlinedColor }) => outlinedColor};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
  background: ${({ background }) => background || "transparent"};
`;

const ControlButton = styled.button`
  width: 40px;
  height: 40px;
  font-size: 1.5rem;
  font-weight: bold;
  border-radius: 50%;
  background: ${({ background }) => background || "transparent"};
  color: ${({ textColor, themeStyle }) =>
    textColor || (themeStyle === "dark" ? "white" : "black")};
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
  cursor: pointer;

  &:hover {
    background: ${({ themeStyle, background }) =>
    background
      ? background
      : themeStyle === "dark"
        ? "rgba(255,255,255,0.1)"
        : "rgba(0,0,0,0.05)"};
    transform: scale(1.05);
  }
`;

const QuantityText = styled.div`
  padding: 0 15px;
  min-width: 24px;
  text-align: center;
  color: ${({ textColor, themeStyle }) =>
    textColor || (themeStyle === "dark" ? "white" : "black")};
`;